// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"22":"datenschutz","42":"impressum"}[chunkId] || chunkId) + "." + {"22":"13ce7434","42":"741ce5b3","264":"8e267126"}[chunkId] + ".js";
};